
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { WorkNameDDLAPI, WorkSubTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const FromReadingDayDDL = (props) => {
    const { ReadingFromDay, setReadingFromDay } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    const [workTypeID, setworkTypeID] = useState('')



    useEffect(() => {
        handleWorkNameDDL()
    }, [])

    const handleWorkNameDDL = () => {
        const WorkNameData = Array.from({ length: 31 }, (_, i) => ({
            id: String(i + 1)
        }));
        if (WorkNameData && WorkNameData.length > 0) {
            let list = WorkNameData.map((item, index) => ({
                value: item.id,
                label: item.id,
            }))
            setReadingFromDay({
                DDL: list,
                ID: 0,
                Label: "Select...",
            })
        }
        else {
            setReadingFromDay({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    const handleChange = (e) => {
        e ?
            setReadingFromDay({ ...ReadingFromDay, ID: e.value, Label: e.label })
            :
            setReadingFromDay({ ...ReadingFromDay, ID: 0, Label: "Select..." })
    }

    return (
        <div className="form-group">
            {/* <label for="" className=""><b>From Reading Day </b></label> */}

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: ReadingFromDay.ID, label: ReadingFromDay.Label }}
                onChange={(e) => {
                    handleChange(e)
                }}
                options={ReadingFromDay.DDL}
            />
        </div>
    )
}